import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import EventButton from '../../../modules/analytics/components/EventButton/EventButton';
import { FloatPropType } from '../../../services/proptypes';
export default function CarouselArrow(_ref) {
  var orientation = _ref.orientation,
    onToggle = _ref.onToggle,
    currentIndex = _ref.currentIndex;
  return /*#__PURE__*/React.createElement(EventButton, {
    "aria-label": "See ".concat(orientation === 'right' ? 'next' : 'previous', " image"),
    event: {
      category: 'Image-Collection',
      action: 'Click',
      label: orientation
    },
    secondary: true,
    circular: true,
    icon: "angle ".concat(orientation),
    onClick: function onClick() {
      return onToggle(currentIndex + (orientation === 'right' ? 1 : -1));
    },
    className: "ic-carousel-arrow",
    style: _objectSpread({}, orientation === 'right' ? {
      right: -15
    } : {
      left: -15
    })
  });
}